/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_PagesInputs */

const en_mobile_scan_pages = /** @type {(inputs: Mobile_Scan_PagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan pages`)
};

const es_mobile_scan_pages = /** @type {(inputs: Mobile_Scan_PagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escanear páginas`)
};

/**
* | output |
* | --- |
* | "Scan pages" |
*
* @param {Mobile_Scan_PagesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_pages = /** @type {((inputs?: Mobile_Scan_PagesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_PagesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_pages(inputs)
	return en_mobile_scan_pages(inputs)
});